var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2686_30967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8378 3H12.5045C12.0625 3 11.6385 3.17559 11.326 3.48816C11.0134 3.80072 10.8378 4.22464 10.8378 4.66667V14.6667C10.8378 15.5507 11.189 16.3986 11.8141 17.0237C12.4393 17.6488 13.2871 18 14.1712 18C15.0552 18 15.9031 17.6488 16.5282 17.0237C17.1533 16.3986 17.5045 15.5507 17.5045 14.6667V4.66667C17.5045 4.22464 17.3289 3.80072 17.0163 3.48816C16.7038 3.17559 16.2799 3 15.8378 3Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8378 6.62535L9.17116 4.95868C8.85861 4.64623 8.43477 4.4707 7.99283 4.4707C7.55089 4.4707 7.12704 4.64623 6.81449 4.95868L4.45783 7.31535C4.14537 7.62789 3.96985 8.05174 3.96985 8.49368C3.96985 8.93562 4.14537 9.35947 4.45783 9.67201L11.9578 17.172",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8378 6.62535L9.17116 4.95868C8.85861 4.64623 8.43477 4.4707 7.99283 4.4707C7.55089 4.4707 7.12704 4.64623 6.81449 4.95868L4.45783 7.31535C4.14537 7.62789 3.96985 8.05174 3.96985 8.49368C3.96985 8.93562 4.14537 9.35947 4.45783 9.67201L11.9578 17.172",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08785 11.333H4.17118C3.72916 11.333 3.30523 11.5086 2.99267 11.8212C2.68011 12.1337 2.50452 12.5576 2.50452 12.9997V16.333C2.50452 16.775 2.68011 17.199 2.99267 17.5115C3.30523 17.8241 3.72916 17.9997 4.17118 17.9997H14.1712",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08785 11.333H4.17118C3.72916 11.333 3.30523 11.5086 2.99267 11.8212C2.68011 12.1337 2.50452 12.5576 2.50452 12.9997V16.333C2.50452 16.775 2.68011 17.199 2.99267 17.5115C3.30523 17.8241 3.72916 17.9997 4.17118 17.9997H14.1712",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1712 14.667V14.6753",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2686_30967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    transform: "translate(0.0045166 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.3812a2b104f753e143475bd041123cc9.svg";
export { ForwardRef as ReactComponent };